import { formatMessage } from "../../helpers/LanguageHelper";
import { CopyCutPasteMessagePanelProps } from "../../../components/layout/CopyCutPasteMessagePanel";

export type PanelErrorType =
  | "NO_CC_SELECTED"
  | "CANNOT_PASTE_INSIDE_CC"
  | "CANNOT_PERFORM_ACTION_ON_DOCUMENT_PART_INCLUDE";

type ErrorObjDataType = Record<PanelErrorType, CopyCutPasteMessagePanelProps>;

export const ERROR_INFO: ErrorObjDataType = {
  CANNOT_PASTE_INSIDE_CC: {
    title: formatMessage("cof.base.paste"),
    message: formatMessage("cof.cutcopypaste.message.error.cannotpaste.insideobject"), //"You cannot paste inside a object",
    alt: formatMessage("cof.cutcopypaste.message.error.cannotpaste.insideobject"),
    imageSrc: "/assets/noObject.svg",
  },

  CANNOT_PERFORM_ACTION_ON_DOCUMENT_PART_INCLUDE: {
    title: formatMessage("fwk.common.warnings"),
    message: formatMessage("cof.objects..message.error.impossibletorun"), //"The operation cannot be executed on this object",
    alt: formatMessage("cof.objects..message.error.impossibletorun"),
    imageSrc: "/assets/noObject.svg",
  },

  NO_CC_SELECTED: {
    title: formatMessage("cof.base.document"),
    message: formatMessage("cof.objects.edit.message.anyfindeditableobject"),
    alt: formatMessage("cof.objects.edit.message.anyfindeditableobject"),
    imageSrc: "/assets/noObject.svg",
  },
} as const;
